
import { Component, Input } from "@angular/core";
import { IconComponent } from "./icon.component";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'expand-icon',
    template: `
<icon icon="expand_24px" [ngClass]="{expanded: expanded}"></icon>`,
    styles: [`
icon { transition: 0.4s; transform: rotate(0deg); color: rgba(0,0,0,0.4);}
icon.expanded { transform: rotate(180deg); }
  `],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class ExpandIconComponent {
  @Input() expanded = false
}
                